/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Pause_Reasons_First_NameInputs */

const en_tables_pause_reasons_first_name = /** @type {(inputs: Tables_Pause_Reasons_First_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reasons First Name`)
};

const de_tables_pause_reasons_first_name = /** @type {(inputs: Tables_Pause_Reasons_First_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorname`)
};

/**
* | output |
* | --- |
* | "Reasons First Name" |
*
* @param {Tables_Pause_Reasons_First_NameInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_pause_reasons_first_name = /** @type {((inputs?: Tables_Pause_Reasons_First_NameInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Pause_Reasons_First_NameInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_pause_reasons_first_name(inputs)
	return de_tables_pause_reasons_first_name(inputs)
});